export const xs = "@media (max-width: 425px)";
export const sm = "@media (max-width: 768px) ";
export const md = "@media (max-width: 1024px)";
export const lg = "@media (max-width: 1440px)";

export const xsForHook = "(max-width:425px)";
export const smForHook = "(max-width:768px)";
export const mdForHook = "(max-width:1024px)";
export const lgForHook = "(max-width:1440px)";
